// Bubble menu: テキスト選択時に出る浮遊フォーマットツールバー
// Lexical の selection 監視 + tippy.js で実装

import { $getSelection, $isRangeSelection, FORMAT_TEXT_COMMAND } from "lexical"
import { $isLinkNode, TOGGLE_LINK_COMMAND } from "@lexical/link"

export function attachBubbleMenu(editor, element) {
  if (!element) return () => {}

  let visible = false

  const positionAtSelection = () => {
    const sel = window.getSelection()
    if (!sel || sel.rangeCount === 0 || sel.isCollapsed) return null
    const rect = sel.getRangeAt(0).getBoundingClientRect()
    if (rect.width === 0 && rect.height === 0) return null
    return rect
  }

  const show = (rect) => {
    if (!visible) {
      element.style.display = "flex"
      document.body.appendChild(element)
      element.style.position = "fixed"
      element.style.zIndex = "999"
      visible = true
    }
    const w = element.offsetWidth
    const left = Math.max(8, rect.left + (rect.width - w) / 2)
    const top  = Math.max(8, rect.top - element.offsetHeight - 8)
    element.style.left = `${left}px`
    element.style.top  = `${top}px`
  }

  const hide = () => {
    if (!visible) return
    element.style.display = "none"
    visible = false
  }

  const update = () => {
    editor.read(() => {
      const sel = $getSelection()
      if (!$isRangeSelection(sel) || sel.isCollapsed()) {
        hide()
        return
      }
      const rect = positionAtSelection()
      if (rect) show(rect)
      else hide()

      // active state 反映 (data-active 属性で CSS が拾う)
      element.querySelectorAll("[data-format]").forEach(btn => {
        const format = btn.dataset.format
        if (format === "link") {
          const nodes = sel.getNodes()
          const hasLink = nodes.some(n => $isLinkNode(n.getParent()) || $isLinkNode(n))
          btn.dataset.active = hasLink ? "1" : "0"
        } else {
          btn.dataset.active = sel.hasFormat(format) ? "1" : "0"
        }
      })
    })
  }

  // ボタンのクリックを Lexical commands にバインド
  element.querySelectorAll("[data-format]").forEach(btn => {
    btn.addEventListener("mousedown", (e) => {
      e.preventDefault()
      const format = btn.dataset.format
      if (format === "link") {
        const url = window.prompt("URL を入力 (http://, https://, mailto:)", "")
        if (url === null) return
        editor.dispatchCommand(TOGGLE_LINK_COMMAND, url === "" ? null : url)
      } else {
        editor.dispatchCommand(FORMAT_TEXT_COMMAND, format)
      }
    })
  })

  const unregister = editor.registerUpdateListener(update)
  document.addEventListener("selectionchange", update)
  document.addEventListener("scroll", update, true)

  // active 状態のスタイル付与 (CSS 側でハイライト)
  element.classList.add("akebono-bubble-menu")

  return () => {
    unregister()
    document.removeEventListener("selectionchange", update)
    document.removeEventListener("scroll", update, true)
    hide()
  }
}
